<ul *ngIf="watchlistElements?.length > 0"
    class="watchlists"
    [ngClass]="{'watchlists--tile-view': tileView}">
  <li *ngFor="let watchlistElement of watchlistElements; trackBy:identifyWatchlistElement"
      class="watchlists__entry"
      [ngClass]="{'watchlists__entry--disabled': watchlistElement.missingContent }">
    <a *ngIf="!watchlistElement.missingContent"
       class="watchlists__entry__inner"
       [routerLink]="watchlistElement.routerLink"
       [queryParams]="watchlistElement.queryParams">
      <div class="watchlists__entry__image">
        <img p1Img
             [fileId]="watchlistElement.imageUuid"
             [fallback]="'assets/images/placeholder-image/watchlist/' + watchlistElement.imageFallback"
             [alt]="watchlistElement.imageAltText || watchlistElement.name"
             width="96"
             height="96"
             loading="lazy">
        <p1-lib-ui-elements-counter-badge *ngIf="watchlistElement.itemCount"
                          class="watchlists__entry__image__counter"
                          [count]="watchlistElement.itemCount">
        </p1-lib-ui-elements-counter-badge>
      </div>
      <div class="watchlists__entry__information">
        <div *ngIf="watchlistElement.subtitleAbove"
             class="watchlists__entry__information__subtitle--above">
          {{watchlistElement.subtitleAbove}}
        </div>
        <div *ngIf="watchlistElement.name"
             class="watchlists__entry__information__title">
          <p1-lib-ui-elements-badge *ngIf="watchlistElement.type === ElementType.ProductSpecification" [inline]="true" [dark]="true" i18n="">Specification</p1-lib-ui-elements-badge>
          {{watchlistElement.name}}
        </div>
        <div *ngIf="watchlistElement.subtitleBelow"
             class="watchlists__entry__information__subtitle--below">
          {{watchlistElement.subtitleBelow}}
        </div>
        <div *ngIf="watchlistElement.comment"
             class="watchlists__entry__comment">
          <i class="icon"><p1-lib-icons-icon-wrapper name="iconComment"></p1-lib-icons-icon-wrapper></i>
          {{watchlistElement.comment}}
        </div>
      </div>
    </a>

    <div *ngIf="watchlistElement.missingContent"
         class="watchlists__entry__inner">
      <div class="watchlists__entry__image">
        <img [src]="'assets/images/placeholder-image/watchlist/' + watchlistElement.imageFallback"
             width="96"
             height="96"
             loading="lazy">
      </div>
      <div class="watchlists__entry__information">
        <div [ngSwitch]="watchlistElement.type"
             class="watchlists__entry__information__title">
          <span *ngSwitchCase="ElementType.Product"
                i18n="watchlist product not available // page: watchlist-detail @@watchlist-content-list.component_product-not-available">
            This product is no longer available
          </span>
          <span *ngSwitchCase="ElementType.Supplier"
                i18n="watchlist supplier not available // page: watchlist-detail @@watchlist-content-list.component_supplier-not-available">
            This supplier is no longer available
          </span>
          <span *ngSwitchCase="ElementType.Comparison"
                i18n="watchlist comparison not available // page: watchlist-detail @@watchlist-content-list.component_comparison-not-available">
            This comparison is no longer available
          </span>
          <span *ngSwitchCase="ElementType.Query"
                i18n="watchlist query not available // page: watchlist-detail @@watchlist-content-list.component_query-not-available">
            This search query is no longer available
          </span>
          <span *ngSwitchCase="ElementType.ProductValidation"
                i18n="watchlist product validation not available // page: watchlist-detail @@watchlist-content-list.component_product-validation-not-available">
            This product validation is no longer available
          </span>
          <span *ngSwitchDefault
                i18n="watchlist element not available // page: watchlist-detail @@watchlist-content-list.component_element-not-available">
            This element is no longer available
          </span>
        </div>
      </div>
    </div>

    <ul class="watchlists__entry__cta-area">
      <li *ngIf="canRemove">
        <button p1Button
                buttonType="link-style-secondary"
                (click)="removeItem.emit(watchlistElement)"
                title="Remove"
                i18n-title="title for remove icon on watchlists detail page // page: watchlist content list page @@watchlist-content-list.component_title-remove">
          <i class="icon">
            <p1-lib-icons-icon-wrapper name="iconBin"></p1-lib-icons-icon-wrapper>
          </i>
        </button>
      </li>
      <li>
        <button *ngIf="canComment"
                p1Button
                buttonType="link-style-secondary"
                (click)="commentItem.emit(watchlistElement)"
                title="Edit note"
                data-gtm-event-category="WatchList"
                [attr.data-gtm-event-action]="'Open comment watchlist element dialog - uuid ' + watchlistElement.uuid + ' - type ' + watchlistElement.type"
                data-gtm-event-label="MyWatchList - Comment Element - Button"
                i18n-title="title for edit note element icon on watchlists detail page // page: watchlist content list page @@watchlist-content-list.component_title-note">
          <i class="icon">
            <p1-lib-icons-icon-wrapper name="iconCommentEdit"></p1-lib-icons-icon-wrapper>
          </i>
        </button>
      </li>
    </ul>
  </li>
</ul>
